module.exports = __webpack_public_path__ + "static/img/logo.d6d7f4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1